import Loadable from 'react-loadable';
import LoadingComponent from '../../common/loader/index';

export default [
    {
        path: '/appointment',
        exact: true,
        auth: true,
        component: Loadable({
            loader: () => import('./index'),
            loading: LoadingComponent
        })
    },
    {
        path: '/work-list',
        exact: true,
        auth: true,
        component: Loadable({
            loader: () => import('../../pages/WorksContainer'),
            loading: LoadingComponent
        })
    },
    {
        path: '/work-assignment',
        exact: true,
        auth: true,
        component: Loadable({
            loader: () => import('../workAssignment/index'),
            loading: LoadingComponent
        })
    },
    {
        path: '/work-assignment/:id',
        exact: true,
        auth: true,
        component: Loadable({
            loader: () => import('../workAssignment/index'),
            loading: LoadingComponent
        })
    },
    {
        path: '/absence-calendar',
        exact: true,
        auth: true,
        component: Loadable({
            loader: () => import('../absentCalendar/index'),
            loading: LoadingComponent
        })
    },
    {
        path: '/serviceNoteDetail/cancelOrder',
        exact: true,
        auth: true,
        component: Loadable({
            loader: () => import('../../pages/AbsentOrderContainer'),
            loading: LoadingComponent
        })
    }
];
